export default __webpack_public_path__ + "static/media/m_engineering_card13_2.49df94ca.png";